module.exports = __webpack_public_path__ + "static/media/openai.fc9fc82b.svg";